// src/tools/drawing/buildingTool.js

export const buildingTool = {
  _startDrawing: null,
  _stopDrawing: null,

  initialize: (map, options) => {
    console.log('Building tool initialized');
    if (options.drawingControls) {
      buildingTool._startDrawing = options.drawingControls.startDrawing;
      buildingTool._stopDrawing = options.drawingControls.stopDrawing;
    }
  },
  activate: (type, defaultProperties) => {
      console.log('Building tool activated');
      // Здания - это полигоны с указанным типом
      buildingTool._startDrawing?.('polygon', defaultProperties);
  },
  deactivate: () => {
    console.log('Building tool deactivated');
    buildingTool._stopDrawing?.();
  },
  cleanup: () => {},
};